import React from 'react';
import {
  mapRiggingJobDisplayStatus,
  riggingJobStatusLabel,
} from '../../features/riggingJobStatus';

export default function RiggingJobStatusBadge({ job, workerRuntimeEnabled }) {
  const display = mapRiggingJobDisplayStatus({
    ...job,
    workerRuntimeEnabled,
  });
  return (
    <span
      className={`status-pill status-${display}`}
      data-testid="rigging-job-status"
      title={job.status_reason || ''}
    >
      {riggingJobStatusLabel(display)}
    </span>
  );
}
